import styled from 'styled-components';

// Components
import { Button, Menu, Space } from 'top-component-library';

// Constants
import { button } from 'constants/style';

export const SearchContainer = styled.div`
  ul {
    border: 1px solid var(--color-neutral__line);
  }
`;

export const CardsContainer = styled(Space)`
  width: 100%;
  .button-container {
    display: flex;
    justify-content: center;
  }
`;

export const LocationCard = {
  Container: styled.div`
    text-align: start;
    color: var(--color-neutral__body);
    background-color: var(--color-neutral__card-background);
    border: 1px solid var(--color-neutral__line);
    border-radius: var(--border-radius__small);
  `,

  LocationCardBody: styled.div`
    padding: 23px;
  `,

  LocationCardBodyHeader: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
  `,

  LocationName: styled.span`
    font-weight: bold;
    color: var(--color-primary__regular);
  `,

  LocationDistance: styled.span`
    font-size: 12px;
  `,

  LocationPhoneAddress: styled.div`
    font-size: 12px;
  `,

  StartOrderButton: styled(Button)`
    width: 100%;
    height: ${button.regular}px;
    opacity: 0.7;
    border-radius: 0 0 var(--button__border-radius) var(--button__border-radius);
    background-color: var(--color-neutral__line);
    color: var(--color-button-landing-page__regular);
    border: none;

    &:hover {
      opacity: 1;
      background-color: var(--color-neutral__line);
      color: var(--color-button-landing-page__regular);
    }
  `,
};

export const MenuItem = styled(Menu.Item)`
  display: flex;
  align-items: center;
  height: 42px;
  export border-bottom: ${(props) => (props.last ? 'none' : '1px solid var(--color-neutral__line)')};
  export justify-content: ${(props) => (props.aligncenter ? 'center' : 'space-between')};

  .distance {
    font-weight: lighter;
  }
`;

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AddressInputContainer = styled.div`
  margin-bottom: 2rem;
`;
